import * as React from 'react';
import * as I18n from 'i18n-js';

import DismissibleSidebar from './dismissible_sidebar';
import RQLFacets from './rql_facets';
import { Filter, WidgetType } from './search_filters';
import { useUser } from '../user_hooks';
import SelectFacet from './select_facet';
import FilterChip from './filter_chip';
import { excludedFilters } from './marketplace_filter_row';
import CoreLink from './core_link';
import { Paths } from '../url_helpers';
import { useURL } from '../url_context';

interface IProps {
  filters: Filter[];
  loading?: boolean;
  subtitle?: string;
  trackingQuery?: string;
}

export default function MarketplaceFilterSidebar({
  filters = [],
  loading = false,
  subtitle = '',
  trackingQuery = '',
}: IProps) {

  const sort = filters.find(filter => filter.widgetType === WidgetType.SORT);
  const user = useUser();
  const { pathname, query } = useURL();

  const clearFilterUrl = pathname?.includes('/marketplace') ?
    Paths.marketplace.expand({ query: query?.query }) : pathname;

  const selectedFilterCounts = filters.map(f => {
    const key = f.aggregationName || f.key;
    if (excludedFilters(user, pathname).includes(key)) return;
    const selectedOptions = f.options.filter(o => {
      if (o.all) return false;
      if (key === 'SHIPS_TO' && o.optionValue === user.shippingRegionCode) return false;
      return o.selected;
    });
    return selectedOptions?.length;
  });

  const selectedFiltersTotal = selectedFilterCounts.length > 0 && selectedFilterCounts.reduce((total, f) => {
    return f > 0 ? total + f : total;
  });

  return (
    <>
      <DismissibleSidebar
        title={I18n.t('commons.marketplaceFilters.filterYourSearch')}
        subtitle={subtitle}
        footerButtonText={I18n.t('commons.marketplaceFilters.viewResults')}
        trigger={
          <span className="mr-1">
            <FilterChip
              loading={loading}
              count={selectedFiltersTotal}
              mobileOnlyCount
            >
              <span className="fa fa-sliders mr-1" />
              <span className="mobile-d-none d-inline">
                {I18n.t('commons.marketplaceFilters.allFilters')}
              </span>
              <span className="mobile-d-inline d-none">
                {I18n.t('commons.marketplaceFilters.filterAndSort')}
              </span>
            </FilterChip>
          </span>
        }
      >
        {sort &&
          <div className="d-none mobile-d-block pb-2 mb-2 bdb-1 bd-primary">
            <SelectFacet
              filter={sort}
              trackingQuery={trackingQuery}
            />
          </div>
        }
        <RQLFacets
          filters={filters}
          loading={loading}
          trackingQuery={trackingQuery}
        />
      </DismissibleSidebar>
      {selectedFiltersTotal > 0 &&
        <CoreLink
          to={clearFilterUrl}
          className="filter-chip filter-chip--text-link"
        >
          {I18n.t('commons.marketplaceFilters.clearFilters')}
        </CoreLink>
      }
    </>
  );
}
